import { call } from "@saas/api-client";
import { Badge, Card, ErrorAlert, Loading, PageHeader, Table, useAsync } from "@saas/ui";
import { Link } from "react-router";
import { api } from "./api";

const monthName = (iso: string) => new Date(iso).toLocaleString(undefined, { month: "long", year: "numeric", timeZone: "UTC" });

export function UsagePage() {
  const usage = useAsync(() => call(api.GET("/api/usage")), []);
  const tenants = usage.data?.tenants ?? [];

  return (
    <>
      <PageHeader
        title="Usage"
        description="Rooms and bookings per tenant. Reading each tenant's numbers enters that tenant's data, so every view is recorded in the audit log, once per tenant."
      />
      <Card title={usage.data ? `Bookings made in ${monthName(usage.data.monthStart)} (UTC)` : "Bookings this month"}>
        <ErrorAlert error={usage.error} />
        {usage.loading && !usage.data ? (
          <Loading />
        ) : tenants.length === 0 ? (
          <p className="sb-muted">No tenants yet.</p>
        ) : (
          <Table caption={`${tenants.length} tenant(s)`} headers={["Tenant", "Status", "Active rooms", "Bookings this month"]}>
            {tenants.map((t) => (
              <tr key={t.tenantId} data-testid={`usage-${t.tenantId}`}>
                <td>
                  <Link to={`/tenants/${t.tenantId}`}>{t.tenantName}</Link>
                </td>
                <td>{t.tenantActive ? <Badge tone="success">Active</Badge> : <Badge tone="warning">Suspended</Badge>}</td>
                <td data-testid="usage-rooms">{t.activeRooms}</td>
                <td data-testid="usage-bookings">{t.bookingsThisMonth}</td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </>
  );
}
